import { OptionType } from '@/app/utils/optionSelectType'
import { ControlProps, CSSObjectWithLabel, GroupBase } from 'react-select'

export const customStyles = {
  control: (
    base: CSSObjectWithLabel,
    props: ControlProps<OptionType, false, GroupBase<OptionType>>,
  ): CSSObjectWithLabel => ({
    ...base,
    borderRadius: '6px',
    border: props.isFocused ? '2px solid black' : '1px solid hsl(var(--input))',
    boxShadow: 'black',
    '&:hover': {
      border: '1px solid hsl(var(--input))',
    },
    backgroundColor: 'white',
  }),
  placeholder: (base: CSSObjectWithLabel) => ({
    ...base,
    color: 'black',
  }),
}
